// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"702":"fea2e44e24d2bb3d2121","715":"34dd6ecb43cd754170af","805":"1635f670d4c22dedebcf"}[chunkId] + ".css";
};